// Initialize swiper slider
function initializeSwiper(swiperElm) {
  new Swiper(swiperElm, {
    slidesPerView: 3,
    spaceBetween: 25,
    loop: false,
    navigation: {
      nextEl: ".nira-filter-section .swiper-button-next",
      prevEl: ".nira-filter-section .swiper-button-prev",
    },
    breakpoints: {
      0: {
        spaceBetween: 15,
        centeredSlides: false,
        slidesPerView: "1.2",
      },
      1200: {
        spaceBetween: 25,
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });
}

// Filter tab section
if (!customElements.get("filter-tab")) {
  // Filter tab section element
  class FilterTabs extends HTMLElement {
    constructor() {
      super();
      var _this = this;
      // Initialize swiper slider
      this.waitForSwiper(function () {
        _this.querySelectorAll(".swiper-container")?.forEach(function (swiper) {
          initializeSwiper(swiper);
        });
      });
      // Filter tab item
      this.dispatchEvent("#filter-tabs li", this.showFilterTabs.bind(this));
      // Filter based on type
      this.dispatchEvent(
        ".nira-tab-content-box .nira-row .filter-details ul li",
        this.filterTabOnType.bind(this)
      );
      // Click on individual slide item
      this.dispatchEvent(
        ".nira-filter-section .nira-tab-content-box .filter-box",
        this.filterIndividualItem.bind(this)
      );

      // Show zero index tab
      document.querySelector("#filter-tabs li")?.click();
    }

    /**
     * Global functions
     */
    // Remove class
    removeClass(selector, cls) {
      document.querySelectorAll(selector)?.forEach(function (elm) {
        elm.classList.remove(cls);
      });
    }

    // Dispatch event handler
    dispatchEvent(selector, trigger) {
      document.querySelectorAll(selector)?.forEach(function (elm) {
        elm.addEventListener("click", function (event) {
          trigger(this);
        });
      });
    }

    // Wait for swiper slider
    waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if (typeof Swiper !== "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 10);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    // wait for jqyer
    waitForjQuery(trigger) {
      var interval = setInterval(function () {
        if (window.jQuery !== undefined) {
          clearInterval(interval);
          trigger(window.jQuery);
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    /**
     * Top filter section
     */
    // Show filter tab
    showFilterTabs(event) {
      var targetElm = event;
      if (targetElm.classList.contains("active")) return;

      // Remove active class
      this.removeClass(".nira-tab-content-box > .nira-row", "nira-active-tab");
      this.removeClass("#filter-tabs li", "active");
      this.removeClass(
        ".nira-tab-content-box .filter-details li",
        "active_filter"
      );

      // Add active class
      targetElm.classList.add("active");

      // Add class
      var tabid = targetElm.getAttribute("data-tabid");
      if (tabid) {
        var tabElm = document.querySelector(
          `.nira-tab-content-box .nira-row[tabid="${tabid}"]`
        );
        tabElm?.classList.add("nira-active-tab");
        var filterItem = tabElm?.querySelector(".filter-details li");
        filterItem?.classList.add("active_filter");

        // Remove active class
        this.removeClass(
          `.nira-tab-content-box .nira-row[tabid="${tabid}"][tabfilter="${filterItem?.id}"] .filter-box`,
          "active_fitlerBox"
        );
        // Active fitler tab
        document
          .querySelectorAll(
            `.nira-tab-content-box .nira-row[tabid="${tabid}"][tabfilter="${filterItem?.id}"] .filter-box`
          )[0]
          ?.classList.add("active_fitlerBox");

        // Filter slide data
        this.filterSlideData(tabid, filterItem?.id, 0);
      }
    }

    // Show filter tab based on filter type
    filterTabOnType(event) {
      var targetElm = event;

      // Return active tab
      if (targetElm.classList.contains("active_filter")) return;

      var tabFilter = targetElm.id;
      var tabid = targetElm.closest("[tabid]")?.getAttribute("tabid");

      // Remove active class
      this.removeClass(".nira-tab-content-box > .nira-row", "nira-active-tab");
      this.removeClass(
        ".nira-tab-content-box .filter-details li",
        "active_filter"
      );

      // Add active class
      var newTabElm = document.querySelector(
        `.nira-tab-content-box .nira-row[tabid="${tabid}"][tabfilter="${tabFilter}"]`
      );
      newTabElm?.classList.add("nira-active-tab");
      var filterItem = newTabElm?.querySelector(
        `.filter-details li#${tabFilter}`
      );
      filterItem?.classList.add("active_filter");

      // Remove active class
      this.removeClass(
        `.nira-tab-content-box .nira-row[tabid="${tabid}"][tabfilter="${filterItem?.id}"] .filter-box`,
        "active_fitlerBox"
      );
      // Active fitler tab
      document
        .querySelectorAll(
          `.nira-tab-content-box .nira-row[tabid="${tabid}"][tabfilter="${filterItem?.id}"] .filter-box`
        )[0]
        ?.classList.add("active_fitlerBox");

      // Filter slide data
      this.filterSlideData(tabid, filterItem?.id, 0);
    }

    // Filter individual element
    filterIndividualItem(event) {
      var targetElm = event;
      // If already active
      if (targetElm.classList.contains("active_fitlerBox")) return;

      var targetSec = targetElm.closest("[tabid]"),
        tabid = targetSec?.getAttribute("tabid"),
        tabFilterId = targetSec?.getAttribute("tabfilter"),
        index = targetElm.getAttribute("filterindex");

      // add active class
      this.removeClass(
        `.nira-tab-content-box .nira-row[tabid="${tabid}"][tabfilter="${tabFilterId}"] .filter-box`,
        "active_fitlerBox"
      );
      targetElm.classList.add("active_fitlerBox");

      // Filter slide data
      this.filterSlideData(tabid, tabFilterId, index);
    }

    /**
     * Build and insert tab before after functionality
     */
    // Build  thumbnails
    buildThumbnails(images) {
      var html = `
       <div class="nira-before-thumbnails swiper-container">
        <div class="swiper-wrapper">`;

      images.forEach(function (image) {
        html += `
           <div class="swiper-slide" data-img-title="{{image_alt}}">
              <span><img src="${image["before"]}"/></span> 
           </div> `;
      });

      html += ` </div>
           </div>`;
      return html;
    }

    // Build gallery
    buildGallery(images) {
      var html = ``;

      images.forEach(function (image) {
        html += `
          <div class="swiper-slide" data-img-title="${image}">
              <div class="r_beforeAfter_image">
                  <div class="multi-ba-day-label-container single">
                      <div class="multi-ba-day-label one"> Day 1 </div>
                      <div class="multi-ba-day-label ninety"> Day 90 </div>
                  </div>
                  <a name="beforeafter" class="anchor"></a>
                  <div class="r_beforeAfterContent">
                      <div id="control" style="height: 100%; position: absolute; width: 62px; right: auto; top: 50%;" class="ui-draggable ui-draggable-handle">
                          <div class="control-block">
                              <span class="icon grid-slider"></span>
                          </div>
                          <span class="line" style="height: 432px;"></span>
                      </div>
                      <div id="r_slideInner">
                          <div id="r_a_before" style="width: 50%; display: block; background-image: url('${image["before"]}'); background-size: cover;"></div>
                          <div id="r_a_after" data-src="${image["after"]}" style="width: 100%; background-image: url('${image["after"]}'); background-size: cover;"></div>
                          <img id="r_beforeImg" data-src="${image["before"]}" src="${image["before"]}" alt="">
                      </div>
                  </div>
              </div>
          </div>`;
      });

      return html;
    }

    // Build progress bar
    buildProgressBar(progressbars) {
      var html = "";
      progressbars.forEach(function (progress) {
        html += `
          <nira-progress-bar tgValue="${progress["fill"]}">
            <div class="progress-bar-box">
                <span class="progress-bar-count" id="target-count-elm">0%</span>  
                <div class="progress-bar" style="--count: 0;"></div>
                <p>${progress["text"]}</p>
            </div>
          </nira-progress-bar>`;
      });
      return html;
    }

    // Build result section
    buildResult(data, index) {
      var slide = data["slides"][index] || data["slides"][0];

      return `
      <before-after-element class="nira-result-before-after">
          <div class="nira-container">
              <div class="nira-result-header">
                  <div class="nira-header-breadcrumb">${data.name} > ${
        slide.label
      } results </div>
              </div>
              <div class="nira-row nira-flex-center">

                  <!----- Left section ------->
                  <div class="nira-col-4 nira-col-left">
                      <h2>${data.heading}</h2>
                      <div class="progress-bar-section">${this.buildProgressBar(
                        slide.progress
                      )}</div>
                  </div>

                  <!---Right section -------->
                  <div class="nira-col-8 nira-col-right">
                      <div class="nira-after-effect nira-row">
                          <!---- Thumbnails -------->  
                          <div class="nira-col-40">${this.buildThumbnails(
                            slide.images
                          )}</div>
                          <!---- Gallery -------->  
                          <div class="nira-col-60">
                           <div class="nira-before-gallery swiper-container">
                               <div class="swiper-wrapper">${this.buildGallery(
                                 slide.images
                               )}</div>
                            </div>
                          </div>        
                      </div>
                  </div>

              </div>
          </div>
      </before-after-element>`;
    }

    // Filter data
    filterSlideData(tabid, resultid, index) {
      var data = window.filterData.concat().filter(function (item) {
        return item.tabid == tabid && item.resultId == resultid;
      });
      data = data[0];
      if (data) {
        var html = this.buildResult(data, index);
        // filter boxes
        var filterBox = document.querySelector(
          ".nira-filter-section #nira-before-after-box"
        );
        if (filterBox) {
          filterBox.innerHTML = html;
        }
      }
    }
  }
  customElements.define("filter-tab", FilterTabs);

  /**
   * Before after element class
   */
  class BeforeAfterEffect extends HTMLElement {
    constructor() {
      super();
      var filterTab = document.querySelector("filter-tab");

      // Generate swiper
      filterTab.waitForSwiper(this.mainSlider);

      // Before after effect
      filterTab.waitForjQuery(this.beforeAfterEffect);
    }

    // Before after effect
    beforeAfterEffect() {
      var $ = window.jQuery;

      // Before after effect
      $(".nira-result-before-after .r_beforeAfterContent").each(function (
        i,
        el
      ) {
        $(el)
          .find("#control")
          .draggable({
            axis: "x",
            containment: "parent",
            drag: function (e, ui) {
              $(el)
                .find("#r_a_before")
                .css("width", ui.position.left + 34 + "px");
            },
          })
          .trigger("drag");
      });
    }

    // Main slider
    mainSlider() {
      // Main swiper slider
      var mainSwiper = document.querySelector(
        ".nira-result-before-after .nira-before-gallery"
      );
      if (mainSwiper) {
        var swiperThumbs = document.querySelector(
          ".nira-result-before-after .nira-before-thumbnails"
        );

        // thumbnails
        var gthumbs = new Swiper(swiperThumbs, {
          slidesPerView: 5,
          spaceBetween: 20,
          slidesPerColumn: 2,
          slidesPerGroup: 6,
          loop: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          direction: "vertical",
          navigation: {
            nextEl: ".nira-before-thumbnails .swiper-button-next",
            prevEl: ".nira-before-thumbnails .swiper-button-prev",
          },
          breakpoints: {
            0: {
              spaceBetween: 8,
              centeredSlides: false,
              slidesPerView: "5",
            },
            1200: {
              spaceBetween: 20,
              slidesPerView: 5,
              centeredSlides: false,
            },
          },
        });

        // Main swiper
        var swiper = new Swiper(mainSwiper, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          allowTouchMove: false,
          effect: "fade",
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          //   pauseOnMouseEnter: true, // Pause autoplay on mouse enter
          //   pauseOnMouseLeave: true, // Resume autoplay on mouse leave
          // },
          thumbs: {
            swiper: gthumbs,
          },
        });

        // Pause autoplay on mouse enter
        swiper.el?.addEventListener("mouseenter", function () {
          swiper.autoplay.stop();
        });

        // Resume autoplay on mouse leave
        swiper.el?.addEventListener("mouseleave", function () {
          swiper.autoplay.start();
        });
      }
    }
  }
  customElements.define("before-after-element", BeforeAfterEffect);
}

// Progress bar animation
if (!customElements.get("progress-bar")) {
  var alreadyCounted = false;
  class ProgressBar extends HTMLElement {
    constructor() {
      super();
      this.targetValue = this.getAttribute("tgValue");
      this.showProgressBar();
    }

    showProgressBar() {
      // Target element
      var counterElement = this.querySelector("#target-count-elm");
      var barElm = this.querySelector(".progress-bar");

      // Counter variables
      var targetValue = this.targetValue;

      // percentage
      counterElement.textContent = targetValue + "%";
      let percent = (targetValue * 100) / 100;
      barElm?.style.setProperty("--count", percent + "%");
    }

    counter() {
      // Target element
      var counterElement = this.querySelector("#target-count-elm");
      var barElm = this.querySelector(".progress-bar");

      // Counter variables
      var targetValue = this.targetValue;
      var animationDuration = 2000; // Animation duration

      // Is animating
      let isAnimating = false;

      var startCounterAnimation = () => {
        if (isAnimating) return;

        isAnimating = true;
        let counter = 0;
        var increment = Math.ceil(targetValue / (animationDuration / 16));

        var animateCounter = () => {
          counter += increment;
          if (counter >= targetValue) {
            counter = targetValue;
            isAnimating = false;
          } else {
            requestAnimationFrame(animateCounter);
          }
          counterElement.textContent = counter + "%";

          // percentage
          let percent = (counter * 100) / 100;
          barElm.style.setProperty("--count", percent + "%");
        };

        animateCounter();
      };

      startCounterAnimation();
    }
  }
  customElements.define("nira-progress-bar", ProgressBar);

  /**
   * On window scroll show progress bar
   */
  function debounce(func, timeout = 30) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  // Element in viewport
  function isInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < window.pageYOffset + window.innerHeight &&
      left < window.pageXOffset + window.innerWidth &&
      top + height > window.pageYOffset &&
      left + width > window.pageXOffset
    );
  }

  // Progress bar
  function progressBarAnimation() {
    var bars = document.querySelectorAll("nira-progress-bar");
    if (bars.length > 0) {
      bars.forEach(function (bar) {
        if (typeof bar.counter !== "undefined") {
          bar.counter();
        }
      });
    }
  }

  // Verify progressbar viewport
  function isProgressBarInViewport() {
    var progressBar = document.querySelector("nira-progress-bar");
    var progressSection = document.querySelector(
      ".nira-container .progress-bar-section"
    );
    if (progressBar && isInViewport(progressBar) && !alreadyCounted) {
      alreadyCounted = true;
      progressBarAnimation();
    } else if (progressSection && !isInViewport(progressSection)) {
      alreadyCounted = false;
    }
  }

  var processChange = debounce(() => isProgressBarInViewport());

  // On window scroll
  window.addEventListener("scroll", function () {
    processChange();
  });
}
